import { IResizerConfig } from "@ducks/config/types";

export enum CONTENT_IMAGETYPE {
  detail = "details",
  card_portrait = "card_portrait",
  card_landscape = "card_landscape",
  coupon_image = "coupon_image",
  vendor = "vendor",
  listing_image = "listing_image",
  banner_mobile = "banner_mobile"
}

export function resizeImage(
  url: string,
  resizerConfig: IResizerConfig,
  type: CONTENT_IMAGETYPE | null | undefined = undefined
): string {
  const baseUrl = resizerConfig.url;
  let imageParams = resizerConfig.config.default;
  if (type) {
    switch (type) {
      case CONTENT_IMAGETYPE.detail:
        imageParams = resizerConfig.config.detail;
        break;
      case CONTENT_IMAGETYPE.card_landscape:
        imageParams = resizerConfig.config.card_landscape;
        break;
      case CONTENT_IMAGETYPE.coupon_image:
        imageParams = resizerConfig.config.coupon_image;
        break;
      case CONTENT_IMAGETYPE.vendor:
        imageParams = resizerConfig.config.vendor;
        break;
      case CONTENT_IMAGETYPE.listing_image:
        imageParams = resizerConfig.config.listing_image;
        break;
      case CONTENT_IMAGETYPE.banner_mobile:
        imageParams = resizerConfig.config.banner_mobile;
        break;
      default:
        break;
    }
  }
  return `${baseUrl}/${imageParams}/${url}`;
}
